import React from 'react';
import { Button, Empty, Spin } from 'antd';
import Util from '../../script/util';
import './index.scss';

// 加载中 loading
export const DDLoading = ({
  className,
  children,
  status = false,
  tip = '加载中...',
  ...otherProps
}) => {
  let wrapperClassNames = '';
  const classNames = Util.classNames(className, { 'global-loading': true });
  if (!!children) {
    wrapperClassNames = Util.classNames(className, {
      'global-wrap-loading': true,
    });
  }

  return (
    <Spin
      {...otherProps}
      tip={null}
      spinning={status}
      wrapperClassName={wrapperClassNames}
      className={classNames}
      indicator={
        <div className="global-animate-wrap">
          <span className="global-animate-icon" />
          <span className="global-animate-text">{tip}</span>
        </div>
      }
    >
      {children}
    </Spin>
  );
};

// 空内容
export const DDEmpty = ({
  className,
  children,
  description = '暂无数据',
  isShowImage = true,
  customImage = null,
  ...otherProps
}) => {
  return (
    <Empty
      {...otherProps}
      description={description}
      className={Util.classNames('global-empty', className)}
      image={isShowImage ? <span className="global-icon-empty" /> : customImage}
    >
      {children}
    </Empty>
  );
};

// 加载异常
export const DDLoadingError = ({
  className,
  onRefresh,
  description = '网络加载异常请稍后再试',
  ...otherProps
}) => {
  return (
    <Empty
      {...otherProps}
      description={description}
      className={Util.classNames('global-loading-error', className)}
      image={<span className="global-icon-loading-error" />}
    >
      {onRefresh && (
        <Button className="global-btn-refresh" onClick={onRefresh}>
          点击重试
        </Button>
      )}
    </Empty>
  );
};

// 网络异常
export const DDNetWork = ({ className, ...otherProps }) => {
  return (
    <Empty
      {...otherProps}
      description={null}
      className={Util.classNames('global-network', className)}
      image={<span className="global-icon-network" />}
    />
  );
};

// 网络异常
export const DDPageErr = ({ className, status, ...otherProps }) => {
  return status === 'error' ? (
    <DDLoadingError {...otherProps} className={className} />
  ) : status === 'network' ? (
    <DDNetWork {...otherProps} className={className} />
  ) : null;
};
